import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getTeachersById,
  resetTeacherPass,
  updateTeacher,
} from "../../../ReduxToolkit/Slices/adminSlice";
import {
  getStudentById,
  updateStudent,
} from "../../../ReduxToolkit/Slices/studentSlice";
import EditForm from "./EditForm";
import "./EditTeacher.styles.scss";

export default function EditTeacher() {
  const dispatch = useDispatch();

  const params = useParams();

  const location = useLocation();
  const navigate = useNavigate();

  const [user, setUser] = useState({});
  const [student, setStudent] = useState({});
  const [password, setPassword] = useState();
  const [teacher, setTeacher] = useState({ subjects: [], categories: [] });

  const { id } = params;

  let role = location.pathname.includes("students") ? "Student" : "Teacher";

  const updateUser = (payloadUser) => {
    setUser({
      password: "",
      name: payloadUser?.name ? payloadUser?.name : "",
      lastName: payloadUser?.lastName ? payloadUser?.lastName : "",
      gender: payloadUser?.gender ? payloadUser?.gender : "MALE",
      email: payloadUser?.email ? payloadUser?.email : "",
      address: {
        country: payloadUser?.address?.country
          ? payloadUser.address.country
          : "",
        state: payloadUser?.address?.state ? payloadUser.address.state : "",
        city: payloadUser?.address?.city ? payloadUser.address.city : "",
        street: payloadUser?.address?.street ? payloadUser.address.street : "",
        zipCode: payloadUser?.address?.zipCode
          ? payloadUser.address.zipCode
          : "",
      },
      profileImage: {
        url: payloadUser?.profileImage?.url
          ? payloadUser?.profileImage?.url
          : "",
        publicId: payloadUser?.publicId?.url ? payloadUser?.publicId?.url : "",
        id: payloadUser?.profileImage?.id ? payloadUser?.profileImage?.id : "",
      },
    });
  };

  useEffect(() => {
    if (role === "Teacher") {
      dispatch(getTeachersById(id)).then((res) => {
        setTeacher(res.payload);
        let payloadUser = res.payload?.user;
        updateUser(payloadUser);
      });
    } else {
      dispatch(getStudentById(id)).then((res) => {
        setStudent(res.payload.data);
        let payloadUser = res.payload?.data?.user;
        updateUser(payloadUser);
      });
    }
  }, [dispatch, id, role]);

  const updateTeachers = () => {
    dispatch(
      updateTeacher({
        teacher: {
          title: teacher.title,
          description: teacher.description,
          hourlyRate: teacher.hourlyRate,
          skills: teacher.skills,
          experience: {
            title: teacher.experience.title,
            qualifications: teacher.experience.qualifications,
            certifications: teacher.experience.certifications,
            experienceYears: teacher.experience.experienceYears,
          },
          background: {
            status: teacher.background?.status
              ? teacher.background?.status
              : "UNCHECKED",
            image: teacher.background?.image
              ? teacher.background?.image
              : { url: "", publicId: "" },
          },
          images: teacher.images.map((image) => {
            return {
              url: image?.url ? image?.url : "",
              publicId: image?.publicId ? image.publicId : "",
              id: image?.id ? image.id : "",
            };
          }),
          videos: teacher.videos.map((image) => {
            return {
              url: image?.url ? image?.url : "",
              publicId: image?.publicId ? image.publicId : "",
              id: image?.id ? image.id : "",
            };
          }),
          user,
          languages: teacher.languages.map((lang) => {
            return {
              name: lang.name,
              proficiency: lang.proficiency,
              id: lang.id,
            };
          }),
          location: teacher.location,
        },
        id: teacher.id,
      })
    ).then((res) => {
      if (res.payload === "Email already in use") {
        alert("Email already in use");
      } else {
        alert("Thank you, teacher was updated!");
        navigate(-1);
      }
    });
  };

  const updateStudents = () => {
    dispatch(
      updateStudent({
        student: {
          paymentMethod: student.paymentMethod,
          user: {
            name: user.name,
            email: user.email,
            phone: user.phone,
            lastName: user.lastName,
            nationality: user.nationality,
            gender: user.gender,
            profileImage: {
              publicId: user.profileImage.publicId,
              url: user?.profileImage?.url,
            },
            address: {
              street: user.address.street,
              city: user.address.city,
              state: user.address.state,
              country: user.address.country,
              zipCode: user.address.zipCode,
            },
          },
        },
        id,
      })
    ).then((res) => {
      if (res.payload === "Email already in use") {
        alert("Email already in use");
      } else if (res.type.includes("fulfilled")) {
        toast.success("Student Edited Successfully!");
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const onSubmit = () => {
    if (role === "Teacher") {
      updateTeachers();
    } else {
      updateStudents();
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  // Navigate to the "Edit Availability" page
  const handleEditAvailability = () => {
    navigate(`/teachers/subjects/1`);
  };
  

  return (
    user.name && (
      <div>
        <button
          onClick={handleEditAvailability}
          style={{
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            fontSize: "16px",
            borderRadius: "5px",
            cursor: "pointer",
            margin: "10px 0",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            transition: "background-color 0.3s",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
        >
          Edit Availability
        </button>

        <EditForm
          onChange={onChange}
          onSubmit={onSubmit}
          role={role}
          user={user}
        />
      </div>
    )
  );
}
